import { render, staticRenderFns } from "./member-role-scope.vue?vue&type=template&id=fba50d04"
import script from "./member-role-scope.vue?vue&type=script&lang=js"
export * from "./member-role-scope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports